import React, { Component } from 'react';
import { Field } from 'redux-form';
import { Row, Col, Badge, Translate } from '$common';
import CSSModules from 'react-css-modules';
import style from '../task-form.scss';



let FormField = props => (
  <div styleName="form-field">
    <label htmlFor={props.name}>{props.label}</label>
    <Field
      name={props.name}
      type={props.type || 'text'}
      component={props => {
        return(
          <input
            type={props.type}
            placeholder={props.placeholder}
            className={props.className}
            defaultValue={props.input.value}
            onBlur={props.input.onChange}
          />
        )
      }}
      styleName="field"
      placeholder={props.placeholder || ''}
    />
  </div>
);
FormField = CSSModules(FormField, style);

export default class VideoCapture extends Component {
  static type = 'video_capture';
  static elementName = Translate.get('video_capture');
  static icon = 'play';

  getData() {
    const data = super.getData();
    data.limit = data.limit || { type: 'character' };
    return data;
  }

  render() {
    const { errors, data } = this.props;

    return (
      <div>
        <Row>
          <Col md="2/4">
            <FormField name={`${data}.limit[min]`} label={Translate.get('second_limit')} type="number" placeholder={Translate.get('min_second_label')}/>
          </Col>
          <Col md="2/4">
            <FormField name={`${data}.limit[max]`} label="&nbsp;" type="number" placeholder={Translate.get('max_second_label')}/>
          </Col>
        </Row>
        {errors && errors.limit ? (
          <Badge type="error">
            {errors.limit}
          </Badge>
        ) : null}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/task-form/question-types/video-capture.js